module.exports = __webpack_public_path__ + "static/media/3136.2f03c4b2.jpg";